import { ChevronLeft, LogOut, Sun, Moon, Settings as SettingsIcon } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";

export default function Header({ title, back = true, onLogout = false, subtitle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, theme, toggleTheme } = useApp();

  return (
    <header
      className="h-16 shrink-0 border-b border-zinc-200 dark:border-zinc-800 bg-white/95 dark:bg-zinc-950/95 backdrop-blur-md sticky top-0 z-40 flex items-center justify-between px-4"
      data-testid="app-header"
    >
      <div className="flex items-center gap-2 min-w-0">
        {back ? (
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 flex items-center justify-center rounded-sm hover:bg-zinc-100 dark:hover:bg-zinc-900 text-zinc-500 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-white transition-colors"
            data-testid="header-back-btn"
            aria-label="Volver"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
        ) : (
          <div className="w-9 h-9 flex items-center justify-center">
            <div className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" />
          </div>
        )}
        <div className="min-w-0">
          <h1
            className="font-display font-bold text-base sm:text-lg uppercase tracking-wider text-zinc-900 dark:text-white truncate"
            data-testid="header-title"
          >
            {title}
          </h1>
          {subtitle && (
            <p className="font-mono-tech text-[10px] text-zinc-500 uppercase tracking-widest truncate">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={toggleTheme}
          className="w-9 h-9 flex items-center justify-center rounded-sm hover:bg-zinc-100 dark:hover:bg-zinc-900 text-zinc-500 dark:text-zinc-400 hover:text-orange-500 transition-colors"
          data-testid="header-theme-toggle"
          aria-label="Cambiar tema"
        >
          {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </button>
        {onLogout && (
          <>
            {location.pathname !== "/settings" && (
              <button
                onClick={() => navigate("/settings")}
                className="w-9 h-9 flex items-center justify-center rounded-sm hover:bg-zinc-100 dark:hover:bg-zinc-900 text-zinc-500 dark:text-zinc-400 hover:text-orange-500 transition-colors"
                data-testid="header-settings-btn"
                aria-label="Ajustes"
              >
                <SettingsIcon className="w-4 h-4" />
              </button>
            )}
            <button
              onClick={() => {
                logout();
                navigate("/login", { replace: true });
              }}
              className="w-9 h-9 flex items-center justify-center rounded-sm hover:bg-zinc-100 dark:hover:bg-zinc-900 text-zinc-500 dark:text-zinc-400 hover:text-orange-500 transition-colors"
              data-testid="header-logout-btn"
              aria-label="Cerrar sesión"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </>
        )}
      </div>
    </header>
  );
}
